export default __webpack_public_path__ + "e59a9623ab0ba0420c823651bc8aa921.svg";